import React from 'react'


const ProductSizes = ({ product, sizes }) => {
    const SizeItem = ({ size, index, id }) => (
        <div className="sc-item pb-1" index={index}>
            <input type="radio" name="sc" id={id} />
            <label htmlFor={id}><span className="align-self-center">{size}</span></label>
        </div>
    )

    // Kiểm tra loại sản phẩm dựa trên tên
    const isChildProduct = product && product.name && product.name.toUpperCase().includes('TRẺ EM');
    const isUmbrellaProduct = product && product.name && (
        product.name.toUpperCase().includes('BÍT') || 
        product.name.toUpperCase().includes('CÁNH DƠI CÀI CẠNH')
    );
    const isRaincoatA2Product = product && product.name && product.name.toUpperCase().includes('BỘ ÁO MƯA 1 LỚP A2 (2 KHÓA)');

    // Render bảng size phù hợp
    const renderSizeTable = () => {
        if (isChildProduct) {
            return (
                <table className="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">SIZE</th>
                            <th scope="col">ĐỘ TUỔI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">S</th>
                            <td>Dưới 8 tuổi</td>
                        </tr>
                        <tr>
                            <th scope="row">M</th>
                            <td>Từ 8 đến 12 tuổi</td>
                        </tr>
                    </tbody>
                </table>
            );
        } else if (isUmbrellaProduct) {
            return (
                <table className="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">SIZE</th>
                            <th scope="col">CHIỀU CAO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1,2m</th>
                            <td>Cao dưới 1m65</td>
                        </tr>
                        <tr>
                            <th scope="row">1,4m</th>
                            <td>Cao trên 1m65</td>
                        </tr>
                    </tbody>
                </table>
            );
        } else if (isRaincoatA2Product) {
            return (
                <table className="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">SIZE</th>
                            <th scope="col">CHIỀU CAO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">M</th>
                            <td>Dưới 145 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">L</th>
                            <td>145 - 149 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">XL</th>
                            <td>150 - 159 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">2X</th>
                            <td>160 - 169 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">3X</th>
                            <td>170 - 178 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">4X</th>
                            <td>Trên 178 cm</td>
                        </tr>
                    </tbody>
                </table>
            );
        } else {
            // Bảng size mặc định cho sản phẩm người lớn
            return (
                <table className="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">SIZE</th>
                            <th scope="col">CHIỀU CAO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">M</th>
                            <td>Dưới 150 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">L</th>
                            <td>Từ 150 đến 159 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">XL</th>
                            <td>Từ 160 đến 169 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">XXL</th>
                            <td>Từ 170 đến 178 cm</td>
                        </tr>
                        <tr>
                            <th scope="row">XXXL</th>
                            <td>Trên 178 cm</td>
                        </tr>
                    </tbody>
                </table>
            );
        }
    };

    return (
        <div className="product-sizes">
            <h3>Chọn Size</h3>
            <div className="sizes-list">
                {sizes.length !== 0 && sizes.map((item, index) => (
                    <SizeItem key={index} index={index} size={item.name} id={item._id} />
                ))}
            </div>

            {renderSizeTable()}
        </div>
    )
}

export default ProductSizes
